import auth from '../../../api/auth'
import { i18n } from '@/plugins/i18n'


export default {

  // --- Toplu fatura listesi tasima -----------------------------------------
  //
  // copertoplufaturaislem sayfasi girdisini adresten degil localStorage'dan
  // okuyor. Bu eskiden SABIT bir anahtarla ("container_toplufatura")
  // yapiliyordu; localStorage tum sekmelerde ortak oldugu icin ikinci sekme
  // birincinin listesini eziyor ve iki sekme ayni faturalari gosteriyordu.
  //
  // Artik her acilista benzersiz bir anahtar uretilip adrese (?liste=...)
  // konuyor. Kimlik URL'de tasindigi icin sekmeler birbirini gormuyor,
  // sayfa yenilense ya da ileri/geri yapilsa da dogru liste kaliyor.

  FATURA_LISTE_ONEK: "container_toplufatura_",

  // ?liste verilmediginde kullanilan eski anahtar. Baska bir giris noktasi
  // ya da eski bir sekme kirilmasin diye korunuyor.
  FATURA_LISTE_ESKI_ANAHTAR: "container_toplufatura",

  // Ayni anda tutulacak azami liste sayisi.
  //
  // Tek anahtar buyuk olabiliyor: paket sayisi 1000 secilirse liste ~90 KB
  // (localStorage UTF-16 sakladigi icin fiilen ~180 KB). Kota origin basina
  // genelde 5 MB, yani ~56 buyuk liste. Yalnizca yasa bakan bir temizlik
  // yogun bir gunde yetmez; bu yuzden ADET de sinirlaniyor.
  FATURA_LISTE_AZAMI_ADET: 10,

  // Ikinci bilesen icin artan sayac.
  //
  // Yalnizca Date.now() yetmiyor: pes pese acilan iki liste ayni milisaniyeye
  // dusebiliyor, o zaman "en yeni hangisi" belirsiz kaliyor ve adet siniri
  // uygulanirken rastgele bir anahtar atilabiliyordu. Sayac ayni milisaniye
  // icindeki sirayi da kesinlestiriyor.
  FATURA_LISTE_SAYAC: 0,

  // Listeyi benzersiz bir anahtara yazar ve anahtari dondurur.
  // Yazilamazsa (kota dolu) null doner; cagiran buna gore uyarir.
  FaturaListesiYaz(degerler) {
    this.FATURA_LISTE_SAYAC += 1;

    var anahtar =
      this.FATURA_LISTE_ONEK + Date.now() + "_" + this.FATURA_LISTE_SAYAC;

    var icerik = JSON.stringify(degerler);

    // Once yer ac: yasi gecmisler ve adet sinirini asan eskiler.
    this.FaturaListesiEskileriTemizle();

    try {
      window.localStorage.setItem(anahtar, icerik);
      return anahtar;
    } catch (e) {
      // Kota dolmus olabilir. Bu ozellige ait TUM anahtarlari bosaltip bir
      // kez daha denenir; boylece dolan alan baska ozellikleri (oturum
      // bilgisi vb.) de kilitlemez.
      this.FaturaListesiTumunuSil();

      try {
        window.localStorage.setItem(anahtar, icerik);
        return anahtar;
      } catch (e2) {
        // Yer hala yoksa cagirana bildirilir; sessizce yanlis liste acmaktansa
        // hic acmamak dogru.
        return null;
      }
    }
  },

  // Bu ozelligin urettigi anahtarlar; yeniden eskiye siralanmis.
  FaturaListesiAnahtarlari() {
    var liste = [];

    for (var i = 0; i < window.localStorage.length; i++) {
      var anahtar = window.localStorage.key(i);

      if (!anahtar || anahtar.indexOf(this.FATURA_LISTE_ONEK) !== 0) {
        continue;
      }

      var parca = anahtar.slice(this.FATURA_LISTE_ONEK.length).split("_");
      var damga = parseInt(parca[0], 10);
      var sayac = parseInt(parca[1], 10);

      // Damgasi okunamayan anahtara dokunulmaz; yanlislikla baska bir sey
      // silinmesin diye listeye de alinmaz.
      if (!isNaN(damga)) {
        liste.push({ anahtar: anahtar, damga: damga, sayac: isNaN(sayac) ? 0 : sayac });
      }
    }

    // Once zamana, esitlikte sayaca gore yeniden eskiye. Sayac olmasa ayni
    // milisaniyedeki anahtarlarin sirasi belirsiz kalir ve adet siniri
    // uygulanirken yanlis olan atilabilirdi.
    liste.sort(function (a, b) {
      if (b.damga !== a.damga) {
        return b.damga - a.damga;
      }
      return b.sayac - a.sayac;
    });

    return liste;
  },

  FaturaListesiTumunuSil() {
    this.FaturaListesiAnahtarlari().forEach(function (k) {
      window.localStorage.removeItem(k.anahtar);
    });
  },

  // Sayfanin okuyacagi anahtar: adreste ?liste varsa o, yoksa eski anahtar.
  FaturaListesiAnahtari(route) {
    var liste = route && route.query ? route.query.liste : null;

    // Yalnizca kendi urettigimiz bicimdeki anahtarlar kabul edilir; adrese
    // elle baska bir localStorage anahtari yazilarak icerik okutulmasin.
    if (liste && String(liste).indexOf(this.FATURA_LISTE_ONEK) === 0) {
      return String(liste);
    }

    return this.FATURA_LISTE_ESKI_ANAHTAR;
  },

  FaturaListesiOku(route) {
    var ham = window.localStorage.getItem(this.FaturaListesiAnahtari(route));

    if (!ham) {
      return null;
    }

    try {
      return JSON.parse(ham);
    } catch (e) {
      return null;
    }
  },

  /**
   * Tarihi saat dilimi eki OLMADAN dondurur.
   *
   *   "2026-08-28T00:00:00+03:00"  ->  "2026-08-28T00:00:00"
   *   "2026-08-20T00:00:00"        ->  "2026-08-20T00:00:00"  (degismez)
   *   "2026-08-20"                 ->  "2026-08-20T00:00:00"
   *   Date nesnesi                 ->  yerel gun/saatiyle metin
   *
   * Ek METINSEL olarak kirpiliyor, Date uzerinden cevrilmiyor. Cevirseydik
   * "2026-08-28T00:00:00+03:00" UTC karsiligi 27 Agustos 21:00 olur ve
   * fatura tarihi BIR GUN GERI kayardi.
   *
   * Ihtiyac: sunucuya giden PNR listesinde bazi tarihler +03:00 ekiyle
   * bazilari eksiz gidiyordu; bu yardimci ikisini ayni bicime getiriyor.
   */
  TarihSaatDilimsiz(deger) {
    if (deger === null || deger === undefined || deger === "") {
      return deger;
    }

    if (deger instanceof Date) {
      var iki = function (n) { return ("0" + n).slice(-2); };
      return deger.getFullYear() +
        "-" + iki(deger.getMonth() + 1) +
        "-" + iki(deger.getDate()) +
        "T" + iki(deger.getHours()) +
        ":" + iki(deger.getMinutes()) +
        ":" + iki(deger.getSeconds());
    }

    var metin = String(deger);

    // Tarih + saat: ekten (Z, +03:00, .123) oncesini al.
    var tamEsleme = metin.match(/^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2})/);
    if (tamEsleme) {
      return tamEsleme[1];
    }

    // Yalnizca gun: gun basiyla ayni bicime getiriliyor.
    var gunEslemesi = metin.match(/^(\d{4}-\d{2}-\d{2})$/);
    if (gunEslemesi) {
      return gunEslemesi[1] + "T00:00:00";
    }

    return metin;   // taninmayan bicim: oldugu gibi birakiliyor
  },

  FaturaListesiSil(route) {
    window.localStorage.removeItem(this.FaturaListesiAnahtari(route));
  },

  // Anahtarlar birikmesin diye IKI olcut birden uygulanir:
  //   1) yasi omurSaat'i gecenler,
  //   2) en yeni FATURA_LISTE_AZAMI_ADET disinda kalan eskiler.
  //
  // Yalnizca yasa bakmak yetmiyordu: bir anahtar 90 KB'a kadar cikabildigi
  // icin ayni gun icinde yapilan yogun islem kotayi doldurabilir.
  // Yazma aninda cagriliyor.
  FaturaListesiEskileriTemizle(omurSaat, azamiAdet) {
    var omur = (omurSaat || 24) * 60 * 60 * 1000;
    var sinir = azamiAdet === undefined ? this.FATURA_LISTE_AZAMI_ADET : azamiAdet;
    var simdi = Date.now();

    // Yeniden eskiye sirali.
    var anahtarlar = this.FaturaListesiAnahtarlari();
    var silinecek = [];

    anahtarlar.forEach(function (k, sira) {
      // Yeni yazilacak anahtara yer birakmak icin sinir-1 tane korunur.
      if (sira >= sinir - 1 || simdi - k.damga > omur) {
        silinecek.push(k.anahtar);
      }
    });

    silinecek.forEach(function (a) {
      window.localStorage.removeItem(a);
    });
  },

  // Earth manuel kurları yalnızca ArkmanTicketStream isteklerinde gönderilir.
  AKTARIM_EARTH_KUR_ANAHTAR: "arkman_aktarim_earth_kurlari_v1",

  AktarimEarthKurlariOku() {
    var ham = window.localStorage.getItem(this.AKTARIM_EARTH_KUR_ANAHTAR);

    if (!ham) {
      return {};
    }

    try {
      var veri = JSON.parse(ham);
      return veri && typeof veri === "object" ? veri : {};
    } catch (e) {
      return {};
    }
  },

  AktarimEarthKurHeaderGetir(url) {
    if (!url || String(url).indexOf("ArkmanTicketStream/") !== 0) {
      return null;
    }

    var kurlar = this.AktarimEarthKurlariOku();
    var satirlar = [];

    Object.keys(kurlar).forEach(function (anahtar) {
      var kur = Number(kurlar[anahtar]);

      if (!isFinite(kur) || kur <= 0) {
        return;
      }

      var parca = String(anahtar).split("|");

      if (parca.length !== 3) {
        return;
      }

      satirlar.push(
        parca[0] + "|" +
        String(parca[1]).toUpperCase() + "|" +
        String(parca[2]).toUpperCase() + "|" +
        kur.toString()
      );
    });

    return satirlar.length > 0 ? encodeURIComponent(satirlar.join(";")) : null;
  },

  AktarimEarthKurHeaderEkle(headers, url) {
    var deger = this.AktarimEarthKurHeaderGetir(url);

    if (deger) {
      headers["AktarimManuelKurlar"] = deger;
    }

    return headers;
  },

  Now_yyyy_MM_dd() {
    let today = new Date();
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  Date_yyyy_MM_dd(val) {
    let today = new Date(val);
    let dd = today.getDate();
    let mm = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd
    }
    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  },

  http_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/Coper/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        // api_post'taki korumanin aynisi: MuhasebeSirketNo bazi giris yollarinda
        // credentials'a hic yazilmiyor ve dogrudan .toString() cagrisi SENKRON
        // patliyor. O zaman promise hic olusmuyor, yani cagiran tarafin .then'i
        // calismiyor: istek gitmedigi gibi loading bayraklari da acik kaliyor.
        // Sunucu tarafi bu basligi zaten try/catch icinde okuyor, 0 zararsiz.
        'MuhasebeSirketNo': (credentials.MuhasebeSirketNo || 0).toString(),

      }
    })
  },

  api_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    let headers = {
      'Authorization': 'Bearer ' + auth.getAuthHeader(),
      'CariSirketNo': credentials.SirketKodu.toString(),
      'CoperSirketNo': credentials.CoperSirketNo.toString(),
      // MuhasebeSirketNo bazi giris yollarinda credentials'a hic yazilmiyor
      // (orn. account/confirm.vue) ve dogrudan .toString() cagrisi SENKRON
      // patliyor: istek hic gitmiyor, kullaniciya da mesaj ulasmiyor.
      // Sunucu tarafi bu basligi zaten try/catch icinde okuyor, 0 zararsiz.
      'MuhasebeSirketNo': (credentials.MuhasebeSirketNo || 0).toString(),
    };

    this.AktarimEarthKurHeaderEkle(headers, url);

    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: headers
    })
  },

  api_post_FileDownload(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader(),
        'CariSirketNo': credentials.SirketKodu.toString(),
        'CoperSirketNo': credentials.CoperSirketNo.toString(),
        'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
      },responseType: "arraybuffer"
    })
  },

  // Indirilen veriyi tarayiciya dosya olarak verir.
  //
  // createObjectURL urettigi adresi tarayici KENDILIGINDEN serbest
  // birakmaz; sayfa yenilenene kadar veri bellekte kalir. Buyuk aktarim
  // dosyalarinda (Logo XML'i ~3 MB) art arda indirmede birikiyordu, bu
  // yuzden indirme basladiktan sonra adres geri veriliyor.
  //
  // Gecikme gerekli: click() indirmeyi eszamanli baslatmiyor, adres hemen
  // iptal edilirse bazi tarayicilarda dosya bos iniyor.
  CreateDownloadLink(response,fileName){
    let contentType = response.headers.get("Content-Type");

    let blob = new Blob([response.data], {
      type: contentType
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    setTimeout(function () { window.URL.revokeObjectURL(link.href); }, 5000);
  },

  OpenPdfInNewTab(response) {
    let blob = new Blob([response.data], { type: 'application/pdf' });
    let blobUrl = window.URL.createObjectURL(blob);
    window.open(blobUrl, '_blank');
  },

  downloadTransferVoucherPdf(owner, pnrNo, lang, showPrice) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (!lang) {
      lang = 'tr';
    }
    if (showPrice === undefined || showPrice === null) {
      showPrice = false;
    }

    return owner.$http.post(
      auth.API_URL +
        `api/Coper/TransferListesiVoucherDownload?pnrNo=${encodeURIComponent(pnrNo)}` +
        `&lang=${encodeURIComponent(lang)}` +
        `&showPrice=${encodeURIComponent(showPrice)}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          'CariSirketNo': credentials.SirketKodu.toString(),
          'CoperSirketNo': credentials.CoperSirketNo.toString(),
          'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        },
        responseType: "arraybuffer",
      }
    ).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
      window.URL.revokeObjectURL(blobUrl);
    });
  },

  downloadHotelVoucherPdf(owner, pnrNo, lang) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));

    if (!lang) {
      lang = 'tr';
    }

    return owner.$http.post(
      auth.API_URL +
        `api/Coper/VoucherPdfDownload?pnrNo=${encodeURIComponent(pnrNo)}` +
        `&lang=${encodeURIComponent(lang)}`,
      {},
      {
        headers: {
          Authorization: "Bearer " + auth.getAuthHeader(),
          'CariSirketNo': credentials.SirketKodu.toString(),
          'CoperSirketNo': credentials.CoperSirketNo.toString(),
          'MuhasebeSirketNo': credentials.MuhasebeSirketNo.toString(),
        },
        responseType: "arraybuffer",
      }
    ).then((response) => {
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const blobUrl = window.URL.createObjectURL(blob);
      window.open(blobUrl, '_blank');
      window.URL.revokeObjectURL(blobUrl);
    });
  },

  api_file_post(owner, url, prm) {
    let credentials = JSON.parse(window.localStorage.getItem('credentials'));
    let headers = {
      'Authorization': 'Bearer ' + auth.getAuthHeader(),
      'CariSirketNo': credentials.SirketKodu.toString(),
      'CoperSirketNo': credentials.CoperSirketNo.toString(),
      'MuhasebeSirketNo': (credentials.MuhasebeSirketNo || 0).toString(),
      'Content-Type': 'multipart/form-data'
    };

    this.AktarimEarthKurHeaderEkle(headers, url);

    return owner.$http.post(auth.API_URL + 'api/' + url, prm, {
      headers: headers
    })
  },


  api_file_post2(owner, url, files, prm) {

    let formData = new FormData();
    for (var i = 0; i < files.length; i++) {
      let file = files[i];
      formData.append('files[' + i + ']', file);
    }

    if (prm==undefined){
      prm={}
    }

    formData.append('jsondata',JSON.stringify(prm))

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    let headers = {
      'Authorization': 'Bearer ' + auth.getAuthHeader(),
      'CariSirketNo': credentials.SirketKodu.toString(),
      'CoperSirketNo': credentials.CoperSirketNo.toString(),
      'MuhasebeSirketNo': (credentials.MuhasebeSirketNo || 0).toString(),
      'Content-Type': 'multipart/form-data'
    };

    this.AktarimEarthKurHeaderEkle(headers, url);

    return owner.$http.post(auth.API_URL + 'api/' + url, formData, {
      headers: headers
    })
  },


  /**
   * Basarisiz bir istekten bir status nesnesi uretir.
   *
   * Govdeyi cozme isi HataMesajiCoz'a birakilir. Eskiden burada yalnizca
   * response.statusText ve body.ExceptionMessage okunuyordu; ArkmanNext'in
   * is kurali hatalarini ve eszamanlilik sinirlayicisinin 429 aciklamasini
   * DUZ METIN govdede gonderdigi icin bunlar goz ardi ediliyordu. Ustelik
   * (HttpStatusCode)429 net462'de tanimli olmadigindan reason phrase de bos
   * geliyor, yani kullanici bombos bir snackbar goruyordu.
   *
   * status === 0 dali da bozuktu: `this` burada bu modul nesnesi oldugu icin
   * this.$t tanimsizdi ve baglanti kopmasinda TypeError firlatiyordu.
   */
  responseToStatus(response, ceviri) {
    let status = this.NewSatatus();
    status.text = this.HataMesajiCoz(response, ceviri);
    status.show = true;
    status.loading = false;
    return status
  },


  NewSatatus() {
    return {
      show: false,
      text: "",
      loading: false,
    }
  },

  /**
   * Basarisiz bir istekten kullaniciya gosterilecek mesaji cikarir.
   *
   * Onceden her hata "Service Unavailable" diye gosteriliyordu; sunucunun
   * asil aciklamasi (orn. "Secilen aralikta aktarilacak fatura bulunamadi")
   * kayboluyordu. ArkmanNext is kurali hatalarini duz metin govdeyle
   * donduruyor, aradigimiz sey orada.
   *
   * `ceviri` = i18n fonksiyonu (genelde `this.$t.bind(this)`). Verilmezse
   * uygulamanin paylasilan i18n ornegi kullanilir; bu sayede eski
   * responseToStatus cagrilari (254 yer) hicbir degisiklik olmadan cevrilmis
   * metin gosterebiliyor.
   */
  HataMesajiCoz(response, ceviri) {
    var $t =
      typeof ceviri === "function"
        ? ceviri
        : function (k) { return i18n.t(k); };

    // status 0 = baglanti kurulamadi; sunucudan gelen bir mesaj yok.
    if (!response || response.status === 0) return $t("Service-Unavailable");

    var govde = response.body !== undefined ? response.body : response.data;

    if (typeof govde === "string" && govde.trim() !== "") {
      return govde.trim().slice(0, 300);
    }

    // Indirme cagrilari responseType "arraybuffer" kullaniyor; hata govdesi de
    // ikili geliyor. Sunucu text/plain UTF-8 gonderdigi icin cozulebilir.
    // "instanceof ArrayBuffer" KULLANILMIYOR: govde baska bir realm'den gelirse
    // (iframe, test ortami) yanlislikla false doner. toString etiketi ve
    // ArrayBuffer.isView ikisi de realm'den bagimsiz calisir.
    var tur = Object.prototype.toString.call(govde);
    if (tur === "[object ArrayBuffer]" || ArrayBuffer.isView(govde)) {
      try {
        var ikili = tur === "[object ArrayBuffer]" ? new Uint8Array(govde) : govde;
        var cozulen = new TextDecoder("utf-8").decode(ikili).trim();
        if (cozulen !== "") return cozulen.slice(0, 300);
      } catch (e) {
        // TextDecoder yoksa ya da icerik metin degilse sessizce gecilir.
      }
    }

    if (govde && typeof govde === "object") {
      // ExceptionMessage ONCE okunur. ASP.NET Web API bir istisnayi hata
      // zarfina sararken Message alanini HER ZAMAN jenerik "An error has
      // occurred." yapar; sunucunun asil aciklamasi (orn. "Tarih veya Date
      // veya Bilet Duzenleme Tarihi Isimli Sutun Excel dosyasinda
      // bulunamadi.") ExceptionMessage'da durur. Ters sirada okundugunda
      // kullanici her sunucu istisnasinda ayni anlamsiz metni goruyordu.
      //
      // CreateErrorResponse / ModelState ile donen dogrulama hatalarinda ise
      // ExceptionMessage hic bulunmaz, oradaki Message'in kendisi anlamlidir;
      // bu yuzden Message yedek olarak korunuyor.
      var m = govde.ExceptionMessage || govde.Message || govde.message;
      if (m) return String(m).slice(0, 300);
    }

    // Govde okunamadi (orn. blob indirmede); en azindan durum kodunu goster.
    return (
      (response.status || "") +
      " " +
      (response.statusText || $t("Service-Unavailable"))
    ).trim();
  }





}